import type { DriverAdvanceBalance } from '@chukua/common';
import { balanceSentence } from '../policies/ledger-amount-labels';

/** What the driver holds against the company, one line per currency and never added together. Restricted when the caller may not see the ledger. */
export function DriverBalancePanel({ balance }: { balance: DriverAdvanceBalance }) {
  return (
    <div className="rounded-lg border border-line bg-surface px-4 py-3">
      <p className="text-sm font-medium text-fg">Advance balance</p>
      <BalanceLines balance={balance} />
    </div>
  );
}

function BalanceLines({ balance }: { balance: DriverAdvanceBalance }) {
  if (!balance.available) return <p className="text-sm text-muted">Not available to your role</p>;
  if (balance.balances.length === 0) return <p className="text-sm text-muted">Nothing owed either way</p>;
  return (
    <ul className="text-sm text-fg">
      {balance.balances.map((line) => (
        <li key={line.currency}>{balanceSentence(line)}</li>
      ))}
    </ul>
  );
}
